import uuid from "node-uuid";

export function generateUUID() {
  // We want to use the :hex formatting of the UUID.
  // ddeb27fb-d9a0-4624-be4d-4615062daed4 -> ddeb27fbd9a04624be4d4615062daed4
  return uuid.v4().split("-").join("");
}